import Model from '../core/model/Model';
import View from '../core/view/View';
import { setup } from '../core/setup/Setup';


/**
 * A image component that renders the src based on the `route` and `params` attributes.
 */
export class Image extends View<ImageModel> {
	constructor() {
		super( { template:'', data:new ImageModel( { route:'image', params:{} } ) } );
	}

	init() {
		this.update();
	}

	update() {
		this.node.setAttribute( 'src', decodeURIComponent( this.data.render() ) );
	}
}


export class ImageModel extends Model {

	route:string;
	params:{};

	render():string {
		return setup.route( this.route, this.params ).url();
	}
}


export default Image;
